import { render, staticRenderFns } from "./MarksModelSelection.vue?vue&type=template&id=523682f6&"
import script from "./MarksModelSelection.vue?vue&type=script&lang=js&"
export * from "./MarksModelSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports